import axios from 'axios'
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";
import {queryBuilder, filters} from '../class/QueryFilter'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

let filtersCopy = JSON.parse(JSON.stringify(filters))

const brandDataShape = (form) => {
    let formData = new FormData();
    formData.append('name', form.name);
    formData.append('slug', form.slug);
    formData.append('language_id', form.language_id);
    if (form.description != null && form.description.trim() !== '') formData.append('description', form.description);
    return formData;
}

const baseUrl = 'https://plus.basalam.com/api/v1.0'


export default {
    namespaced: true,
    state: {
        ...filtersCopy,
        basalamToken: '',
    },
    mutations: {
        setFilters(state, filter) {
            const keys = Object.keys(state.filters)
            for (let i in keys) {
                state.filters[filter.key] = filter.value;
                return
            }
        },
    },
    actions: {
        async getBasalamToken({commit, state}) {
            if (state.basalamToken.length != 0) {
                return state.basalamToken;
            }
            let form = {
                items: [
                    'basalam_token',
                ]
            }
            let req = await axios.post('site-info/get-multiple/item-with-name', form)
            let data = req.data.data
            state.basalamToken = data[0].value
            return state.basalamToken;
        },
        async getCategories({commit, state}) {
            await store.dispatch('Basalam/getBasalamToken')
            let req = await axios.get(`${baseUrl}/user/product/categories`, {
                headers: {
                    'Authorization': `Bearer ${state.basalamToken}`
                }
            })

            return req.data.data
        },
        async getCategoryAttributes({commit, state}, form) {
            await store.dispatch('Basalam/getBasalamToken')
            return axios.get(`${baseUrl}/user/product/category/${form.id}/attributes`, {
                headers: {
                    'Authorization': `Bearer ${state.basalamToken}`
                }
            })
        },
        async getCategoryVariations({commit, state}, form) {
            await store.dispatch('Basalam/getBasalamToken')
            return axios.get(`${baseUrl}/user/product/category/${form.id}/variations`, {
                headers: {
                    'Authorization': `Bearer ${state.basalamToken}`
                }
            })
        },
        async getProduct({commit, state}, form) {
            await store.dispatch('Basalam/getBasalamToken')
            return axios.get(`${baseUrl}/user/product/${form.id}`, {
                headers: {
                    'Authorization': `Bearer ${state.basalamToken}`
                }
            })
        },
        async createProduct({commit, state}, form) {
            await store.dispatch('Basalam/getBasalamToken')
            return axios.post(`${baseUrl}/user/product/add`, form, {
                headers: {
                    'Authorization': `Bearer ${state.basalamToken}`
                }
            })
        },
        async updateProduct({commit, state}, form) {
            await store.dispatch('Basalam/getBasalamToken')
            return axios.post(`${baseUrl}/user/product/edit`, form, {
                headers: {
                    'Authorization': `Bearer ${state.basalamToken}`
                }
            })
        },
        setProductBasalam({commit, state}, form) {
            return axios.post(`basalam/product/${form.id}/set-info`, form)
        },
    },
    getters: {
        getFilters: (state) => state.filters,
    }
}